import { MoreHorizontal } from "lucide-react";
import { cn } from "../../ui/index.js";
import { overlayModeLabel } from "../overlayModes.js";

/** The overlays used every match; the rest live behind "Yana…". */
export const EFIR_TILES = [
  "scoreboard",
  "big",
  "matchid",
  "stats",
  "roster_home",
  "roster_away",
  "little_sponsor",
  "tournament_1_8",
] as const;

const TILE_LABEL: Record<string, string> = {
  roster_home: "Tarkib · Uy",
  roster_away: "Tarkib · Mehmon",
  little_sponsor: "Homiy",
  tournament_1_8: "Jadval",
};

export type TileState = { onAir: boolean; cued: boolean; disabled: boolean; title?: string };

export function OverlayPad({
  tileState,
  onTile,
  onMore,
}: {
  tileState: (mode: string) => TileState;
  onTile: (mode: string) => void;
  onMore: () => void;
}) {
  return (
    <div className="flex flex-col gap-3 rounded-xl border border-border bg-surface p-3">
      <div className="grid grid-cols-2 gap-2 xl:grid-cols-3">
        {EFIR_TILES.map((mode) => {
          const s = tileState(mode);
          return (
            <button
              key={mode}
              data-anchor={`tile:${mode}`}
              type="button"
              disabled={s.disabled}
              title={s.title}
              onClick={() => onTile(mode)}
              className={cn(
                "relative flex h-16 flex-col items-center justify-center rounded-xl border-2 px-2 text-center text-[15px] font-bold transition-colors",
                "disabled:cursor-not-allowed disabled:border-dashed disabled:opacity-35",
                s.cued
                  ? "border-ready-strong bg-ready-strong/15 text-ink"
                  : s.onAir
                    ? "border-live bg-live-soft text-ink"
                    : "border-border bg-surface-elevated text-ink hover:border-ink-faint",
              )}
            >
              {TILE_LABEL[mode] ?? overlayModeLabel(mode)}
              {(s.onAir || s.cued) && (
                <span
                  className={cn(
                    "mt-0.5 text-[10px] font-black uppercase tracking-[0.12em]",
                    s.cued ? "text-ready-strong" : "text-live",
                  )}
                >
                  {s.cued ? (s.onAir ? "Yashirishga tayyor" : "Tayyor") : "Efirda"}
                </span>
              )}
            </button>
          );
        })}
        <button
          type="button"
          onClick={onMore}
          className="flex h-16 items-center justify-center gap-2 rounded-xl border-2 border-dashed border-border text-[15px] font-bold text-ink-muted hover:text-ink"
        >
          <MoreHorizontal className="h-5 w-5" /> Yana…
        </button>
      </div>
    </div>
  );
}
